import { connect } from 'react-redux';
import {
  resetData,
  startTest,
  updateActiveSection,
  updateSubTab,
  updateVastConfigurationUrl,
} from '../../actions';
import SectionsPanel from '../../components/sections/SectionsPanel.js';
import { postConfiguration } from '../../middleware/showcaseMiddleware';

const mapStateToProps = state => {
  return {
    activeSection: state.activeSection,
    subTab: state.subTab,
    vastSource: state.vastSource,
    validationStates: {
      adData: state.adData.isValid,
      adRules: state.adRules.isValid,
      configuration: state.configuration.isValid,
      other: state.other.isValid,
    },
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onClick: () => {
      dispatch(startTest());
    },
    resetData: () => {
      dispatch(resetData());
    },
    updateActiveSection: index => {
      dispatch(updateActiveSection(index));
    },
    updateSubTab: index => {
      dispatch(updateSubTab(index));
    },
    updateVastConfigurationUrl: vastSource => {
      dispatch(updateVastConfigurationUrl(vastSource));
    },
    postConfiguration: () => {
      dispatch(postConfiguration());
    },
  };
};

const SectionsPanelRedux = connect(mapStateToProps, mapDispatchToProps)(SectionsPanel);

export default SectionsPanelRedux;
